import { connect } from 'react-redux';

import BoostModal from './BoostModal';
import { updateBoosting } from '../../actions';

const mapStateToProps = ({ scribeConversation: { isBoosting } }) => ({
  isBoosting,
});

export default connect(mapStateToProps, {
  updateBoosting,
})(BoostModal);
